import { useEffect, useState } from 'react'

import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'
import { onceTimer } from '@/common/util/timer'

export const ModalType = {
  DEFAULT: 'default',
  MIDDLE: 'middle',
  LARGE: 'large',
  DIALOG: 'dialog',
  BOTTOM: 'bottom'
} as const
export type ModalType = (typeof ModalType)[keyof typeof ModalType]

interface Props extends ChildProps {
  show?: boolean
  type?: ModalType
}

const Modal = ({ children, show = false, type = ModalType.DEFAULT }: Props) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    let clearTimer: () => void

    if (show) {
      setVisible(true)
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
      clearTimer = onceTimer(() => setVisible(false), 300)
    }

    return () => {
      clearTimer?.()
      document.body.style.overflow = ''
    }
  }, [show])

  return (
    <div
      className={clsx(
        'z-modal fixed top-0 left-0 h-full w-full',
        show ? 'animate-fade-in visible opacity-100' : 'hidden opacity-0'
      )}
    >
      <div className='bg-modal-overlay absolute top-0 left-0 h-full w-full'></div>
      {visible && (
        <div
          className={clsx(
            'bg-surface shadow-600 absolute',
            type !== ModalType.BOTTOM
              ? 'top-1/2 left-1/2 m-auto flex w-full translate-x-[-50%] translate-y-[-50%] flex-col rounded-2xl'
              : 'top-auto bottom-0 flex h-[calc(100vh-80px)] max-h-[calc(100vh-80px)] w-full max-w-none flex-col rounded-t-2xl',
            type == ModalType.DIALOG
              ? 'max-w-100'
              : type == ModalType.LARGE
                ? 'max-w-[85vw]'
                : type == ModalType.MIDDLE
                  ? 'max-w-214'
                  : 'max-h-[75vh] max-w-160'
          )}
        >
          {children}
        </div>
      )}
    </div>
  )
}

export default Modal
